import { render, staticRenderFns } from "./CustomSetting.vue?vue&type=template&id=268fe866&scoped=true&"
import script from "./CustomSetting.vue?vue&type=script&lang=js&"
export * from "./CustomSetting.vue?vue&type=script&lang=js&"
import style0 from "./CustomSetting.vue?vue&type=style&index=0&id=268fe866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268fe866",
  null
  
)

export default component.exports